var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 84,
    viewBox: "0 0 83 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5003 76.3542C60.6007 76.3542 76.0837 60.8712 76.0837 41.7708C76.0837 22.6705 60.6007 7.1875 41.5003 7.1875C22.4 7.1875 6.91699 22.6705 6.91699 41.7708C6.91699 60.8712 22.4 76.3542 41.5003 76.3542Z",
    fill: "url(#paint0_linear_4569_367)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5003 76.3542C60.6007 76.3542 76.0837 60.8712 76.0837 41.7708C76.0837 22.6705 60.6007 7.1875 41.5003 7.1875C22.4 7.1875 6.91699 22.6705 6.91699 41.7708C6.91699 60.8712 22.4 76.3542 41.5003 76.3542Z",
    fill: "url(#paint1_radial_4569_367)",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5003 76.3542C60.6007 76.3542 76.0837 60.8712 76.0837 41.7708C76.0837 22.6705 60.6007 7.1875 41.5003 7.1875C22.4 7.1875 6.91699 22.6705 6.91699 41.7708C6.91699 60.8712 22.4 76.3542 41.5003 76.3542Z",
    fill: "url(#paint2_radial_4569_367)",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5228 8.64694C30.35 10.509 29.3653 12.483 28.5832 14.5399C26.9232 18.7937 25.6816 23.957 24.9519 29.6667H9.09548C8.46837 31.3382 7.97268 33.0674 7.6084 34.8542H24.447C24.0504 40.6161 24.1522 46.4015 24.7514 52.1459H8.49719C9.06666 53.9442 9.76986 55.6734 10.6068 57.3334H25.4707C26.2142 61.6736 27.269 65.623 28.5832 69.0018C29.4339 71.1805 30.4161 73.1691 31.5228 74.8948C34.7594 75.8661 38.1209 76.3578 41.5001 76.3542C44.8793 76.3578 48.2408 75.8661 51.4774 74.8948C52.6501 73.0327 53.6348 71.0587 54.4169 69.0018C55.7311 65.623 56.7859 61.6736 57.5294 57.3334H72.3934C73.2303 55.6734 73.9335 53.9442 74.5029 52.1459H58.2488C58.8479 46.4015 58.9497 40.6161 58.5531 34.8542H75.3917C75.0319 33.0889 74.5347 31.3545 73.9046 29.6667H58.0447C57.3185 23.957 56.0735 18.7937 54.4135 14.5399C53.6313 12.483 52.6466 10.509 51.4739 8.64694C48.2384 7.67596 44.8781 7.18427 41.5001 7.18752C38.1209 7.18393 34.7594 7.67563 31.5228 8.64694ZM30.1913 29.6667C30.883 24.5829 31.9966 20.0733 33.4214 16.4247C34.6629 13.2431 36.0843 10.8499 37.5506 9.29364C38.9997 7.75123 40.3311 7.18752 41.5001 7.18752C42.669 7.18752 44.0004 7.75123 45.4529 9.29364C46.9158 10.8499 48.3406 13.2431 49.5822 16.4247C51.007 20.0733 52.1206 24.5864 52.8123 29.6667H30.1913ZM41.5001 76.3542C42.6724 76.3542 44.0004 75.7905 45.4529 74.2481C46.9193 72.6918 48.3441 70.2986 49.5856 67.117C50.6785 64.3157 51.588 61.013 52.2659 57.3334H30.7377C31.4156 61.013 32.3286 64.3192 33.4179 67.117C34.6595 70.2986 36.0809 72.6918 37.5472 74.2481C38.9997 75.7905 40.3311 76.3542 41.5001 76.3542ZM29.3959 41.7709C29.3959 45.3952 29.6034 48.8777 29.9734 52.1459H53.0336C53.6767 46.4044 53.7855 40.6157 53.3587 34.8542H29.6414C29.473 37.1559 29.3899 39.463 29.3924 41.7709",
    fill: "url(#paint3_radial_4569_367)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8132 45.2638C71.2181 44.669 65.9372 40.8164 63.5821 38.7967C63.2087 38.4844 62.7374 38.3132 62.2507 38.3132C61.7639 38.3132 61.2926 38.4844 60.9192 38.7967C58.5641 40.8164 53.2797 44.669 46.6882 45.2638C46.2272 45.2979 45.7952 45.5016 45.4758 45.8357C45.1564 46.1698 44.9723 46.6105 44.959 47.0725V59.1767C44.959 73.7812 59.1174 78.9445 61.8114 79.7953C62.0972 79.8859 62.4041 79.8859 62.6899 79.7953C65.3874 78.9445 79.5423 73.7778 79.5423 59.1767V47.0725C79.5282 46.6111 79.3436 46.1713 79.0243 45.8379C78.705 45.5045 78.2735 45.2978 77.8132 45.2638Z",
    fill: "url(#paint4_linear_4569_367)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4569_367",
    x1: 22.2858,
    y1: 18.7141,
    x2: 72.2415,
    y2: 64.8275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2052CB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4569_367",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.8452 59.602) rotate(180) scale(29.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003580",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4569_367",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.1974 59.0625) rotate(37.2782) scale(45.4999 49.3573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#1B44B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B44B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4569_367",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.3706 59.0729) rotate(44.678) scale(52.289 55.8514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#3BD5FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#3BD5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4569_367",
    x1: 51.4434,
    y1: 38.3126,
    x2: 82.7828,
    y2: 75.7352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E794A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.80d12e6684f703a333458336ecf5984e.svg";
export { ForwardRef as ReactComponent };